import { AxiosResponse } from 'axios';
import apiService from './api';
import { GlobalLEReportsPageResponse, GlobalLEReportsPageQueryParams, GlobalLEProgressReportRow, GlobalLEByStationRow, GlobalLEByStudentRow } from 'shared/types';

const REPORTS_PATH = '/reports';

export const getGlobalLEReportsPage = (
  params?: GlobalLEReportsPageQueryParams
): Promise<AxiosResponse<GlobalLEReportsPageResponse>> => {
  return apiService.get<GlobalLEReportsPageResponse>(
    `${REPORTS_PATH}/global-le-reports`,
    params
  );
};

export const getGlobalLEByStation = (
  params: GlobalLEReportsPageQueryParams
): Promise<AxiosResponse<GlobalLEByStationRow[]>> => {
  return apiService.get<GlobalLEByStationRow[]>(
    `${REPORTS_PATH}/global-le-by-station`,
    params
  );
};

export const getGlobalLEByStudent = (
  params: GlobalLEReportsPageQueryParams
): Promise<AxiosResponse<GlobalLEByStudentRow[]>> => {
  return apiService.get<GlobalLEByStudentRow[]>(
    `${REPORTS_PATH}/global-le-by-student`,
    params
  );
};

export const getGlobalLEProgressReports = (
  userId: string,
  leId: string,
  dataSource: string,
  stationNumber?: number
): Promise<AxiosResponse<GlobalLEProgressReportRow[]>> => {
  return apiService.get<GlobalLEProgressReportRow[]>(
    `${REPORTS_PATH}/global-le-progress-reports`,
    {
      user_id: userId,
      learning_experience_id: leId,
      data_source: dataSource,
      ...(stationNumber != null ? { station_number: stationNumber } : {}),
    }
  );
};
